import request from "../utils/request";

export function getPictureUrl(fileName: string, quality?: string, base64?: boolean) {
    return request.request({
        url: '/product/picture',
        method: 'get',
        params: {fileName, quality, base64}
    })
}

export function getCategories() {
    return request.request({
        url: '/product/category/',
        method: 'get'
    })
}

export function getProducts(params: any) {
    return request.request({
        url: '/product/',
        method: 'get',
        params: {
            ...params,
            program: params.program === 'All' ? undefined : params.program
        }
    })
}

export function getProductByQuotation(quotationId: string, type: string, unitType: string) {
    return request.request({
        url: '/product/detail',
        method: 'get',
        params: {quotationId, type, unitType}
    })
}

export function getPriceByQuotation(quotationId: string) {
    return request.request({
        url: '/product/price',
        method: 'get',
        params: {quotationId}
    })
}

export function updateProductFromPink() {
    return request.request({
        url: '/product/update',
        method: 'post'
    })
}
